import classes from '../QBRSentiment.module.scss';

export const settingsMap = {
  Positive: {
    iconClass: classes.icon_positive,
    iconName: 'champion',
    markerClass: classes.marker_positive
  },
  Neutral: {
    iconClass: classes.icon_neutral,
    iconName: 'needAttention',
    markerClass: classes.marker_neutral
  },
  Negative: {
    iconClass: classes.icon_negative,
    iconName: 'sad',
    markerClass: classes.marker_negative
  },
  Other: {
    iconClass: classes.icon_other,
    iconName: 'help',
    markerClass: classes.marker_other
  }
};
